import { create } from 'zustand';

const useThemeStore = create((set) => ({
  isDark: JSON.parse(localStorage.getItem('isDark')) || false,
  
  toggleTheme: () => {
    set((state) => {
      const newDark = !state.isDark;
      localStorage.setItem('isDark', JSON.stringify(newDark));
      return { isDark: newDark };
    });
  },
}));

export default useThemeStore;
